import axios from 'axios'

export default {
    checkResponse(response) {
        if (response) {
            if (!!response.data.deactivated) {
                if (window.location.pathname != '/login') {
                    return window.location.href = '/login';
                }
            } else {
                return response.data
            }
        } else {
            toastr['error']('Ошибка', 'Ошибка');

            return window.location.href = '/login';
        }
    },
    checkCurrentPassword(currentPassword) {
        return axios.get('/users/password/check?password=' + currentPassword)
            .then(response => {

                return this.checkResponse(response);
            })
    },
    updateCurrentUser(user) {

        return axios.post('/users/current-user', user)
            .then(response => {
                if (response) {
                    this.$currentUser = response;
                }
                return this.checkResponse(response)
            })
    },
    getUsers(sort, roleArray) {

        return axios.get('/users/list?role=' + roleArray + '&sortBy=' + sort.sortBy + '&sortDesc=' + sort.sortDesc)
            .then(response => {

                return this.checkResponse(response);
            })
    },
    createUser(user, subordinatesArray) {

        return axios.post('/users/create', {
            name: user.name,
            email: user.email,
            role: user.role,
            network_partner_id: user.network_partner_id,
            market_partner_id: user.market_partner_id,
            subordinates: subordinatesArray,
            newPassword: user.newPassword,
            department: user.department,
            market_user_id: user.market_user_id,
            network_user_id: user.network_user_id,
        })
            .then(response => {

                return this.checkResponse(response)
            })
    },
    updateUser(user, subordinates) {

        return axios.post('/users/update/' + user.id, {
            name: user.name,
            email: user.email,
            network_partner_id: user.network_partner_id,
            market_partner_id: user.market_partner_id,
            role: user.role,
            subordinates: subordinates,
            is_hidden: user.is_hidden,
            deactivated: user.deactivated,
            newPassword: user.newPassword,
            department: user.department,
            market_user_id: user.market_user_id,
            network_user_id: user.network_user_id,
        })
            .then(response => {

                return this.checkResponse(response)
            })
    },
    getAvailableSubordinates() {

        return axios.get('/users/subordinates')
            .then(response => {

                return this.checkResponse(response);
            })
    },
}



// WEBPACK FOOTER //
// ./resources/js/services/usersDataService.js